const inStockCount = document.querySelector('.in-stock-count');
if (inStockCount) {
  let dnkTextCount = inStockCount.querySelector('.dnk-text-count');

  if (dnkTextCount) {
    const countMin = parseInt(dnkTextCount.getAttribute('data-count-min'), 10);
    const countCritical = parseInt(dnkTextCount.getAttribute('data-count-critical'), 10);
    const countMax = parseInt(dnkTextCount.getAttribute('data-count-max'), 10);
    let currentCount = countMax;
    if (localStorage.getItem('remainingTime')) {
      currentCount = parseInt(localStorage.getItem('remainingTime'));
    }
    const randMin = parseInt(dnkTextCount.getAttribute('data-rand-min'), 10);
    const randMax = parseInt(dnkTextCount.getAttribute('data-rand-max'), 10);
    const dnkTextContent = inStockCount.querySelector('.dnk-text-content');

    let beforeQuantity = dnkTextContent.textContent.split('[quantity]')[0];
    let afterQuantity = dnkTextContent.textContent.split('[quantity]')[1];
    dnkTextContent.innerHTML = beforeQuantity + dnkTextCount.outerHTML + afterQuantity;
    dnkTextCount.remove();
    dnkTextCount = inStockCount.querySelector('.dnk-text-count'); // dnkTextCount on new place
    let randomDelay = Math.floor(Math.random() * (randMax - randMin + 1)) + randMin;

    function countdownTimeout() {
      setTimeout(() => {
        startCountdown();
      }, randomDelay * 1000);
    }

    startCountdown();
    inStockCount.classList.remove("js");

    function startCountdown() {
      randomDelay = Math.floor(Math.random() * (randMax - randMin + 1)) + randMin;
      if (currentCount > countMin) {
        currentCount--;
        dnkTextCount.textContent = currentCount;
        localStorage.setItem('remainingTime', currentCount);
        countdownTimeout();
      } else {
        dnkTextCount.textContent = countMin;
      }
      if (currentCount <= countCritical) {
        inStockCount.classList.add('critical-count');
      }
    }
  }
}

document.addEventListener('DOMContentLoaded', function() {
  document.body.addEventListener('click', function(e) {
      if (document.querySelectorAll('#nova-poshta') !== null && document.querySelector('.nova-feature-btn__wrapper') !== null) {
          const miniCartBody = document.querySelector('.cart__drawer .drawer__content');
          if (e.target.closest('.nova-feature-btn__wrapper')) {
              if(miniCartBody !== null) {
                  miniCartBody.classList.add('show-nova-poshta');
              }
              document.querySelector('#nova-poshta').classList.remove('d-none');
          } else if (!e.target.closest('.nova-feature-btn__wrapper') && !e.target.closest('#nova-poshta') && !e.target.classList.contains('link') || e.target.closest('#nova-poshta .form__close')) {
              if(miniCartBody !== null) {
                  miniCartBody.classList.remove('show-nova-poshta');
              }
              document.querySelector('#nova-poshta').classList.add('d-none');
          }
      }
  })
});
function initNova() {
    const novaPoshta = document.querySelector('#nova-poshta');
    const addressWrap = novaPoshta.querySelector('.address-wrap');
    const warehouseWrap = novaPoshta.querySelector('.warehouse-wrap');
    const cityFilter = novaPoshta.querySelector('#city_filter');
    const citySearch = novaPoshta.querySelector('#city-search');
    const warehouseFilter = novaPoshta.querySelector('#warehouse_filter');
    const streetFilter = novaPoshta.querySelector('#street_filter');

    const apiKey = window.nova.key;
    const apiUrlN = window.nova.url;

    quickCityLink();
    clearFields();
    deliveryMethod();
    initCartUrl();

    async function reqAPI(data) {
        try {
            const response = await fetch(apiUrlN, {
                method: 'POST',
                body: JSON.stringify(data),
                credentials: 'same-origin',
                cache: 'no-cache',
                mode: 'cors',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            return response.json();
        } catch (error) {
            //throw error;
            console.log('error');
        }
    }

    novaPoshta.querySelectorAll('input.form-control').forEach(function(item) {
        item.addEventListener('input', function() {
            if (item.value != '') {
                if (item.classList.contains('input-city')) {
                    item.closest('.form-group').querySelector('.clear').classList.remove('d-none');
                    let customerCity = item.value;
                    reqAPI({
                        "apiKey": apiKey,
                        "modelName": "Address",
                        "calledMethod": "searchSettlements",
                        "methodProperties": {
                            "CityName": customerCity,
                            "Limit": "99",
                            "Page": "1"
                        }
                    })
                        .then(res => {
                            if (res.success) {
                                let dataCities = res.data[0].Addresses;
                                cityFilter.innerHTML = '';
                                if (dataCities.length > 0) {
                                    dataCities.forEach(function(item, i) {
                                        
                                        cityFilter.insertAdjacentHTML('beforeend', `
                                                <a class="filter-link city-link link" data-city="${item.MainDescription}" data-delivery-ref="${item.DeliveryCity}" data-ref="${item.Ref}" data-present="${item.Present}" style="display:block;">${item.Present}</a>
                                            `)
                                    })
                                }
                                cityFilter.classList.add('active');
                                cityFilterLink();
                            }
                        })
                        .catch(err => {
                            console.log('error request:', this)
                        })
                }
                 else if (item.classList.contains('input-warehouse') && citySearch.value != '') {
                    item.closest('.form-group').querySelector('.clear').classList.remove('d-none');
                    let findString = item.value;
                    let CityRef = citySearch.dataset.deliveryRef;
                    reqAPI({
                        "apiKey": apiKey,
                        "modelName": "Address",
                        "calledMethod": "getWarehouses",
                        "methodProperties": {
                            "FindByString": findString,
                            "CityRef": CityRef,
                            "Page": "1",
                            "Limit": "99"
                        }
                    })
                        .then(res => {
                            if (res.success) {
                                let warehouses = res.data;
                                warehouseFilter.innerHTML = '';

                                // console.log(warehouses);


                                const input = document.querySelector('.input-warehouse');
                                const value = input.value.trim();
                                const sortedWarehouses = sortWarehousesByInput(warehouses, value);


                                function getWarehouseNumber(description) {
                                    const match = description.match(/№\s*(\d+)/);
                                    return match ? match[1] : null;
                                }

                                function sortWarehousesByInput(warehouses, inputValue) {
                                    // check only number
                                    if (!/^\d+$/.test(inputValue)) {
                                        return warehouses;
                                    }

                                    return [...warehouses].sort((a, b) => {
                                        const numA = getWarehouseNumber(a.Description);
                                        const numB = getWarehouseNumber(b.Description);

                                        if (!numA && !numB) return 0;
                                        if (!numA) return 1;
                                        if (!numB) return -1;

                                        if (numA === inputValue && numB !== inputValue) return -1;
                                        if (numB === inputValue && numA !== inputValue) return 1;

                                        const aStarts = numA.startsWith(inputValue);
                                        const bStarts = numB.startsWith(inputValue);

                                        if (aStarts && !bStarts) return -1;
                                        if (!aStarts && bStarts) return 1;

                                        return Number(numA) - Number(numB);
                                    });
                                }

                                sortedWarehouses.forEach(function(item, i) {
                                    // console.log(item);
                                    warehouseFilter.insertAdjacentHTML('beforeend', `
                                            <a class="filter-link city-link link" data-ref="${item.Ref}" data-present='${item.Description}' style="display:block;">${item.Description}</a>
                                        `)
                                })
                                warehouseFilter.classList.add('active');
                                cityFilterLink();
                            }
                        })
                        .catch(err => {
                            console.log('error request:', this)
                        })
                }
                else if (item.classList.contains('input-street') && citySearch.value != '') {
                    item.closest('.form-group').querySelector('.clear').classList.remove('d-none');
                    let findString = item.value;
                    let сityRef = citySearch.dataset.deliveryRef;
                    reqAPI({
                        "apiKey": apiKey,
                        "modelName": "Address",
                        "calledMethod": "getStreet",
                        "methodProperties": {
                            "CityRef": сityRef,
                            "FindByString": findString,
                            "Page": "1",
                            "Limit": "99"
                        }
                    })
                        .then(res => {
                            if (res.success) {
                                let dataStreets = res.data;
                                streetFilter.innerHTML = '';
                                dataStreets.forEach(function(item, i) {
                                    streetFilter.insertAdjacentHTML('beforeend', `
                                            <a class="filter-link city-link link" data-ref="${item.Ref}" data-present='${item.StreetsType} ${item.Description}' style="display:block;">${item.StreetsType} ${item.Description}</a>
                                        `)
                                })
                                streetFilter.classList.add('active');
                                cityFilterLink();
                            }
                        })
                        .catch(err => {
                            console.log('error request:', this)
                        })
                }
            } else {
                item.dataset.ref = '';
                if (item.closest('.form-group').querySelector('.clear') !== null) {
                    item.closest('.form-group').querySelector('.clear').classList.add('d-none')
                }
                item.closest('.branch_wrap').querySelector('.dropdown-filter').classList.remove('active');
                item.closest('.branch_wrap').querySelector('.dropdown-filter').innerHTML = '';
            }
        })
    })

    function clearField() {
        warehouseWrap.querySelector('input').value = '';
        addressWrap.querySelector('input').value = '';
        novaPoshta.querySelector('.form-build input').value = '';
        novaPoshta.querySelector('.form-flat input').value = '';
    }

    function clearFields() {
        novaPoshta.querySelectorAll('.clear').forEach(function(item) {
            item.addEventListener('click', function() {
                item.classList.add('d-none');
                item.closest('.branch_wrap').querySelector('input').value = '';
                item.closest('.branch_wrap').querySelector('input').dataset.ref = '';
                item.closest('.branch_wrap').querySelector('.dropdown-filter').innerHTML = '';
                item.closest('.branch_wrap').querySelector('.dropdown-filter').classList.remove('active')
            });
        });
    }

    function quickCityLink() {
        novaPoshta.querySelectorAll('a.quick-city-link').forEach(function(item) {
            let startCity = item.textContent;
            reqAPI({
                "apiKey": apiKey,
                "modelName": "Address",
                "calledMethod": "searchSettlements",
                "methodProperties": {
                    "CityName": startCity,
                    "Limit": "99",
                    "Page": "1"
                }
            })
                .then(res => {
                    if (res.success) {
                        item.dataset.ref = res.data[0].Addresses[0].Ref;
                        item.dataset.deliveryRef = res.data[0].Addresses[0].DeliveryCity;
                        item.dataset.present = res.data[0].Addresses[0].Present;
                    }
                })
                .catch(err => {
                    console.log('error request:', this)
                })
            item.addEventListener('click', function(e) {
                if (e.target.closest('.quick-city-link')) {
                    novaPoshta.querySelector('.city-wrap input').value = e.target.dataset.present;
                    novaPoshta.querySelector('.city-wrap input').dataset.ref = e.target.dataset.ref;
                    novaPoshta.querySelector('.city-wrap input').dataset.deliveryRef = e.target.dataset.deliveryRef;
                    novaPoshta.querySelector('.city-wrap .clear').classList.remove('d-none');
                }
                if (e.target.closest('.quick-city-link')) {
                    clearField()
                }
            })
        })
    }

    function cityFilterLink() {
        novaPoshta.querySelectorAll('a.filter-link').forEach(function(item) {
            item.addEventListener('click', function(e) {
                if (e.target.dataset.deliveryRef) {
                    item.closest('.branch_wrap').querySelector('.form-group input').dataset.deliveryRef = e.target.dataset.deliveryRef;
                }
                if (e.target.dataset.city) {
                    item.closest('.branch_wrap').querySelector('.form-group input').dataset.city = e.target.dataset.city;
                    clearField();
                }
                item.closest('.branch_wrap').querySelector('.form-group input').dataset.ref = e.target.dataset.ref;
                item.closest('.branch_wrap').querySelector('.form-group input').value = e.target.dataset.present;
                item.closest('.branch_wrap').querySelector('.form-group .clear').classList.remove('d-none');
                item.closest('.branch_wrap').querySelector('.dropdown-filter').classList.remove('active');
                item.closest('.branch_wrap').querySelector('.dropdown-filter').innerHTML = '';
            })
        })
    }

    function deliveryMethod() {
        document.querySelectorAll('[name="variant"]').forEach(function(item) {
            if(item.id == 'variant-branch') {
                item.click();
            }
            item.addEventListener('change', function(e) {
                if (e.target.id == 'variant-branch') {
                    addressWrap.classList.add('d-none');
                    warehouseWrap.classList.remove('d-none');
                    novaPoshta.querySelector('#address-street').value = '';
                    novaPoshta.querySelector('#address-street').dataset.ref = '';
                    novaPoshta.querySelector('#address-build').value = '';
                    novaPoshta.querySelector('#address-flat').value = '';
                    addressWrap.querySelector('.clear').classList.add('d-none');
                } else if (e.target.id == 'variant-courier') {
                    addressWrap.classList.remove('d-none');
                    warehouseWrap.classList.add('d-none');
                    novaPoshta.querySelector('#warehouse-search').value = '';
                    novaPoshta.querySelector('#warehouse-search').dataset.ref = '';
                    warehouseWrap.querySelector('.clear').classList.add('d-none');
                }
            })
        })
    }

    function initCartUrl() {
        let inputsData = document.querySelectorAll('#nova-poshta .form-control');
        let inputsTypeShip = document.querySelectorAll('#nova-poshta input[name="variant"]');
        let buttCartLink = document.querySelector('#nova-poshta .nova-poshta__button-wrapper a');
        buttCartLink.addEventListener('click', function(e) {
            e.preventDefault();
            if (novaPoshta.querySelector('.dropdown-filter.active') == null) {
                inputsTypeShip.forEach(function(inputTypeShip, i) {
                    var cartContents = fetch(window.Shopify.routes.root + 'cart.js')
                        .then(response => response.json())
                        .then(data => {
                            return data
                        });
                    function getCookie(name) {
                        const nameEQ = name + "=";
                        const cookies = document.cookie.split(';');
                        for (let i = 0; i < cookies.length; i++) {
                            let cookie = cookies[i];
                            while (cookie.charAt(0) === ' ') {
                                cookie = cookie.substring(1);
                            }
                            if (cookie.indexOf(nameEQ) === 0) {
                                return cookie.substring(nameEQ.length, cookie.length);
                            }
                        }
                        return null;
                    }
                    const couponCode = getCookie('coupon-discount');
                    if (inputTypeShip.checked && inputTypeShip.dataset.type == 'branch' && checkInputs('branch') == 2) {
                        let arrInputs = checkInputs('branch', true);
                        if (arrInputs) {
                            let linkCheckout;
                            cartContents.then((value) => {
                                let link = window.Shopify.routes.root + 'checkout';
                                if(couponCode !== null){
                                    link += '?' + 'checkout[shipping_address][city]=' + arrInputs[0].value + '&checkout[shipping_address][address1]=' + arrInputs[1].value + '&checkout[shipping_address][zip]=12345' + `&discount=${encodeURIComponent(couponCode)}`;
                                }else{
                                    link += '?' + 'checkout[shipping_address][city]=' + arrInputs[0].value + '&checkout[shipping_address][address1]=' + arrInputs[1].value + '&checkout[shipping_address][zip]=12345';
                                }

                                // console.log(link);
                                window.open(link, '_top')
                            })

                        }
                    } else if (inputTypeShip.checked && inputTypeShip.dataset.type == 'courier' && checkInputs('courier') > 2) {
                        let checkedInputs = checkInputs('courier', true);
                        if (checkedInputs) {
                            let linkCheckout;
                            cartContents.then((value) => {
                                let kv = '';
                                if (checkedInputs[3].value != '') {
                                    kv = ', кв. ' + checkedInputs[3].value;
                                }
                                let link = window.Shopify.routes.root + 'checkout';
                                if(couponCode !== null){
                                    link += '?' + 'checkout[shipping_address][city]=' + checkedInputs[0].value + '&checkout[shipping_address][address1]=' + checkedInputs[1].value + ', буд. ' + checkedInputs[2].value + kv + '&checkout[shipping_address][zip]=12345' + `&discount=${encodeURIComponent(couponCode)}`;
                                }else {
                                    link += '?' + 'checkout[shipping_address][city]=' + checkedInputs[0].value + '&checkout[shipping_address][address1]=' + checkedInputs[1].value + ', буд. ' + checkedInputs[2].value + kv + '&checkout[shipping_address][zip]=12345';
                                }
                                window.open(link, '_top')
                            })
                        }
                    }
                })
            } else {
                console.log('select dates')
            }
        })

        function checkInputs(type, inputs) {
            if (type == 'branch') {
                let branch = 0;
                let arr = [];
                inputsData.forEach((item) => {
                    if ((item.id == 'city-search' || item.id == 'warehouse-search') && item.value != '') {
                        branch++;
                        arr.push(item);
                    }
                })
                if (inputs == true) {
                    return arr;
                } else {
                    return branch;
                }
            } else if (type == 'courier') {
                let courier = 0;
                let arr = [];
                inputsData.forEach((item) => {
                    if ((item.id == 'city-search' || item.id == 'address-street' || item.id == 'address-build' ) && item.value != '' || item.id == 'address-flat') {
                        courier++;
                        arr.push(item);
                    }
                })
                if (inputs == true) {
                    return arr;
                } else {
                    return courier;
                }
            }
        }
    }
}
document.addEventListener('DOMContentLoaded', function() {
  if (document.querySelector('#nova-poshta') !== null && document.querySelector('.nova-feature-btn__wrapper') == null) {
    console.log("'#nova-poshta') !== nul");
      const elements = document.querySelectorAll('#nova-poshta .js.product-form__input input');
      elements.forEach(el => {
          el.name = 'test';
      });
      setTimeout(function () {
          elements.forEach(el => {
              el.name = 'variant';
          });
          initNova();
      }, 500)
  }
});